export default __webpack_public_path__ + "static/canada-326b38304b21d5f357ae14b9ff7256c9.svg";